import { PocketPickResultsScreen } from '@/screens/pocketPick/PocketPickResultsScreen'

export default function () {
  return <PocketPickResultsScreen />
}
